export default __webpack_public_path__ + "static/media/placeholder.a3d15fda.png";